// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-00dbb91a]{display:block;border-bottom:2px solid #000;color:#000;padding-bottom:1rem;transition:border .33s ease;text-decoration:none}@media(max-width:599px){a[data-v-00dbb91a]{margin-bottom:3rem}}a[data-v-00dbb91a]:hover{border-bottom:2px solid #75943f}a h2[data-v-00dbb91a]{margin-top:1rem}a h2 span[data-v-00dbb91a]{font-size:30px;line-height:29px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
